import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { HolidayItem } from "@/actions/ssr/settings/getHolidaysSSR";

interface HolidaysState {
  items: HolidayItem[];
  totalPages: number;
  currentPage: number;
  count: number;
}

const initialState: HolidaysState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  count: 0,
};

const holidaysSlice = createSlice({
  name: "holidays",
  initialState,
  reducers: {
    setHolidays(
      state,
      action: PayloadAction<{
        results: HolidayItem[];
        total_pages: number;
        current_page: number;
        count: number;
      }>,
    ) {
      state.items = action.payload.results;
      state.totalPages = action.payload.total_pages;
      state.currentPage = action.payload.current_page;
      state.count = action.payload.count;
    },
    setHolidayItems(state, action: PayloadAction<HolidayItem[]>) {
      state.items = action.payload;
    },
    setHolidayPagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        count?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.count !== undefined) {
        state.count = action.payload.count;
      }
    },
  },
});

export const { setHolidays, setHolidayItems, setHolidayPagination } =
  holidaysSlice.actions;
export default holidaysSlice.reducer;
